var $4f461eb266a95c10$exports = {};
$4f461eb266a95c10$exports = {
    "alpha": `Alfa`,
    "blue": `Azul`,
    "brightness": `Luminosidade`,
    "green": `Verde`,
    "hue": `Tonalidade`,
    "lightness": `Claridade`,
    "red": `Vermelho`,
    "saturation": `Satura\xe7\xe3o`
};


export {$4f461eb266a95c10$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
